// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-info-card {
  max-height: 181vh;
  height: auto;
  min-height: 584px;
  border-radius: 10px;
}
.product-site-no {
  font-size: 13px;
  color: #d2042d;
}
.product-info-card .product-title {
  font-size: 17px;
  font-weight: 600;
  color: #0a0a0a;
  font-family: Roboto;
}
.product-info-card .product-location {
  font-size: 14px;
  font-weight: 500;
  font-family: Roboto;
  color: #d2042d;
}
.product-info-card .product-location-details {
  font-size: 16px;
  color: #4b4b4b;
  font-family: Roboto;
}
.price-breakdown-info-text {
  font-size: 12px;
  color: #7a7a7a;
  margin-left: 4px;
  font-family: Roboto;
}
.price-breakdown-info {
  display: flex;
  align-items: center; /* desktop */
  margin-top: 5px;
}
@media (max-width: 768px) {
  .price-breakdown-info {
    align-items: flex-start; /* mobile */
  }
}
.price-breakdown-info svg {
  flex-shrink: 0;
}

.view-full-price-breakdown {
  font-size: 16px;
  color: #d2042d;
  font-family: Roboto;
  text-decoration: underline;
}
.product-type-container {
  margin-top: 8px;
  padding: 4px 8px;
  display: inline-block;
  background-color: #1a1919;
  border-radius: 4px;
}
.product-info-card .product-price {
  font-size: 20px;
  font-weight: 700;
  font-family: Roboto;
  color: #0a0a0a;
}
.select-campaign-dropdown-div {
  position: sticky;
  width: 100% !important;
}

.audience-breakdown-card {
  height: 309px;
  border-radius: 10px;
}
.product-performance-card {
  height: auto;
  border-radius: 10px;
}
.product-performance-title {
  font-size: 14px;
  font-weight: 600;
  font-family: Roboto;
  color: #0a0a0a;
}
.breadcrumb-nav-container {
  margin-top: 16px;
}

.product-type-label {
  font-size: 14px;
  color: #5b5e5d;
  font-family: Roboto;
}

.product-availability-text {
  font-size: 14px;
  color: #5b5e5d;
  font-family: Roboto;
}
.product-type-value {
  font-size: 14px;
  font-family: Roboto;
  color: #0a0f0d;
}
.product-location-card {
  height: auto;
  border-radius: 10px;
}
.product-seller-info-card {
  height: 162px;
  border-radius: 10px;
}
.product-pricebooking-card {
  width: 100%;
  height: auto;
  border-radius: 10px;
}
/* Ensure single month panel is displayed */
.single-panel-picker .ant-picker-panels {
  min-width: 280px; /* Minimum width for single month panel */
  width: auto; /* Let it resize if needed */
}
.similar-product-image-container {
  width: 399px;
  height: 229px;
}
.similar-product-id {
  font-size: 14px;
  color: #8e9190;
  font-family: Roboto;
}
.similar-product-title {
  font-size: 16px;
  font-weight: 500;
  font-family: Roboto;
  color: #0a0a0a;
}
.similar-product-date {
  font-size: 14px;
  font-weight: 500;
  font-family: Roboto;
}
.similar-product-specification-label {
  font-size: 14px;
  color: #5b5e5d;
  font-family: Roboto;
  font-weight: 400;
}
.similar-product-card {
  width: 449px;
  height: 649px;
}

.impressions-column {
  color: #3b3f3d;
  font-size: 14px;
  font-family: Roboto;
  font-weight: 400;
}
.audience-breakdown-total {
  color: #0a0f0d;
  font-size: 16px;
  font-family: Roboto;
  font-weight: 500;
}
.maps-card-section {
  flex: 1 1;
  height: 100%;
  width: 100%;
  overflow: hidden;
  margin-top: 16px;
}
.map-billboard-card .ant-card-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px;
}
.card-width-adjustments {
  padding-top: 10px;
  padding-right: 20px;
  width: 100%;
}
.google-map-container {
  background: lightgray 50% / cover no-repeat;
  border-radius: 19px;
}
.booking-policy-section {
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
}
.product-detail-image-container {
  height: 400px;
  width: 90%;
}
.price-breakdown-popover-content {
  width: 326px;
  padding: 16px 10px;
}
.breakdown-price-label {
  font-size: 16px;
  color: #707070;
  font-weight: 400;
  font-family: Roboto;
}
.breakdown-amount {
  font-size: 16px;
  color: #0a0f0d;
  font-weight: 500;
  font-family: Roboto;
}
.price-breakdown-divider .ant-divider-horizontal {
  margin: 8px 0;
}
.select-quantity-dropdown {
  font-family: Roboto;
  display: flex;
  height: 50px;
  padding: 10px 20px;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d);
  position: sticky;
  width: 21vw !important;
}
.product-information-div {
  width: 74.5%;
  height: 125vh;
  overflow-y: auto;
}
.product-booking-section {
  width: 25%;
}
.radio-btn-campaign {
  font-size: 14px;
  font-family: Roboto;
  font-weight: 400;
}
.error-text {
  font-size: 14px;
  color: #d2042d;
  font-family: Roboto;
}
.warning-msg-text {
  font-size: 14px;
  color: #5b5e5d;
  font-family: Roboto;
  font-weight: 400;
}

.minimum-err-txt-container {
  background-color: #fee1e7;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 8px;
  border-radius: 12px;
  margin-top: 8px;
}
.ant-drawer-content-wrapper {
  pointer-events: none;
}
.ant-drawer-content {
  pointer-events: auto;
}
.ant-select-dropdown {
  position: fixed !important;
}
.ant-drawer {
  transform: none !important;
}

.ant-select-dropdown {
  position: fixed !important;
  z-index: 2000 !important;
}

@media (max-width: 1250px) {
  .audience-breakdown-card {
    height: auto;
    border-radius: 10px;
    max-height: auto;
  }
  .product-performance-card {
    height: auto;
    border-radius: 10px;
  }
  .product-location-card {
    height: auto;
    max-height: auto;
    border-radius: 10px;
  }
}

@media (max-width: 1199px) {
  .card-width-adjustments {
    padding-top: 10px;
    padding-right: 20px;
    width: 100%;
    margin-left: 20px;
  }
  .product-detail-image-container {
    height: 400px;
    width: 100%;
  }
  .product-highlight-detail {
    margin-top: 21vh;
  }
}

@media (max-width: 1024px) {
  .product-info-outer {
    display: flex;
    flex-direction: row;
  }
  .product-information-div {
    width: 60%;
    height: 125vh;
    overflow-y: auto;
  }
  .product-booking-section {
    width: 40%;
  }
}
@media (max-width: 996px) {
  .product-highlight-detail {
    margin-top: 16vh;
  }
  .product-info-card {
    max-height: 181vh;
    height: auto;
    min-height: 564px;
    border-radius: 10px;
  }
  .ant-drawer .ant-drawer-content {
    border-top-left-radius: 30px !important;
    border-top-right-radius: 30px !important;
  }
  .audience-breakdown-card {
    height: auto;
  }
  .maps-card-section {
    height: 100%;
    width: 100%;
    margin-top: 16px;
  }
  .product-pricebooking-card {
    width: 100%;
    height: auto;
    border-radius: 10px;
  }
  .product-detail-image-container {
    height: 400px;
    width: 100%;
  }
  .select-campaign-dropdown-div {
    position: sticky;
    width: 100% !important;
  }
  .select-quantity-dropdown {
    position: sticky;
    max-width: 59vw;
    width: auto;
    min-width: 59vw;
  }
  .product-information-div {
    width: 100%;
    height: 88vh;
    overflow-y: auto;
  }
  /* .product-booking-section {
    display: none;
  } */
}
.product-info-outer {
  display: flex;
  flex-direction: row;
}
.custom-calendar-popup {
  width: 100% !important;
  inset: 25px auto auto 8px !important;
}
@media (max-width: 500px) {
  .product-info-outer {
    display: flex;
    flex-direction: column;
  }
  .product-information-div {
    width: 100% !important;
  }
  .product-booking-section {
    width: 100% !important;
  }
}

@media (max-width: 500px) {
  .select-quantity-dropdown {
    position: sticky;
    max-width: 93vw;
    width: auto;
    min-width: 87vw;
  }
  .select-campaign-dropdown-div {
    position: sticky;
    width: 100% !important;
  }
}
.multiline-truncate {
  display: -webkit-box;
  -webkit-line-clamp: 5; /* Number of lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.fixed-bottom-bar-add-to-campaign {
  position: fixed !important;
  bottom: 0 !important;
  z-index: 1000 !important;
  width: 100% !important;
  border-radius: 0 !important;
}

@media (max-width: 440px) {
  .product-detail-image-container {
    height: 70%;
  }
  .product-highlight-detail {
    margin-top: 3vh;
  }
  .product-info-card .product-title {
    font-size: 20px;
  }
}
/* .multi-slot-range-picker {
  width: 0 !important;
  overflow: hidden;
} */
.multi-slot-range-picker.ant-picker {
  border: none !important;
}
.multi-slot-range-picker .ant-picker-input {
  display: none !important;
}
.multi-slot-range-picker .ant-picker-range-separator {
  display: none !important;
}

.multi-slot-range-picker .ant-picker-suffix {
  display: none !important;
}
.multi-slot-range-picker .ant-picker-clear {
  display: none !important;
}

.multi-range-selection-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 375px;
  width: 100%;
  max-height: 40vh;
  overflow: auto;
}

.multi-range-selection-box {
  width: 100%;
  border: 1.213px solid #ddd;
  border-radius: 12px;
  min-height: 44px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  /* color: #6b7280; */
  font-size: 14px;
  font-weight: 500;
  background: #fff;
  font-family: Roboto;
}
.multi-range-selection-box.clickable-range {
  cursor: pointer;
}
.active-range {
  border: 1px solid #d2042d;
  background-color: #fee1e7;
  color: #d2042d;
}

.range-arrow {
  color: #d90429;
}

.add-another-range-btn {
  border: 1px dashed #d9d9d9;
  border-radius: 12px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8c8c8c;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  background: #fff;
  gap: 7px;
  font-family: Roboto;
}

.add-another-range-btn:hover {
  border-color: #9ca3af;
  color: #374151;
}

.multi-slot-popup {
  z-index: 10 !important;
}

.delete-range-btn {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #e03b59;
}

.delete-range-btn:hover {
  color: #d10b15;
}

.disabled-add-range {
  opacity: 0.5;
  pointer-events: none;
}

.view-slots-link {
  font-family: Roboto;
  cursor: pointer;
  color: #d2042d;
  text-decoration: underline;
}
.product-reservation-banner {
  width: 97%;
  background: #fff1f2;
  border: 1px solid #fca5a5;
  border-top: 4px solid #d2042d;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 24px;
  margin-top: 10px;
}

.product-reservation-main {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
}

.product-reservation-icon {
  width: 48px;
  height: 48px;
  background: #ffe4e6;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.product-reservation-icon .anticon {
  color: #d2042d;
  font-size: 22px;
}

.product-reservation-content {
  flex: 1 1;
}

.product-reservation-title {
  color: #d2042d;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
}

.product-reservation-text {
  color: #344054;
  font-size: 14px;
  line-height: 22px;
}

.product-reservation-timer-wrapper {
  min-width: 170px;
  text-align: center;
}

.product-reservation-timer-label {
  font-size: 13px;
  color: #667085;
  margin-bottom: 8px;
}

.product-reservation-timer {
  background: #344054;
  height: 52px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.product-reservation-timer .anticon {
  color: #fff;
  font-size: 18px;
}

.product-reservation-footer-label {
  margin-top: 8px;
  color: #667085;
  font-size: 12px;
}

.product-reservation-footer {
  background-color: #fff8f8;
  border-top: 1px solid #fca5a5;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #667085;
  font-size: 13px;
}
.product-reservation-footer .anticon {
  color: #d2042d;
}

@media (max-width: 768px) {
  .product-reservation-main {
    flex-direction: column;
    align-items: flex-start;
  }
  .product-reservation-icon {
    align-self: center;
  }
  .product-reservation-content {
    width: 100%;
    text-align: center;
  }
  .product-reservation-timer-wrapper {
    width: 100%;
  }
  .product-reservation-timer {
    width: 100%;
  }
  .product-reservation-footer {
    align-items: flex-start;
  }
  .select-campaign-dropdown-div {
    position: sticky;

    width: 100% !important;
  }
  .product-information-div {
    width: 52% !important;
    overflow-y: auto !important;
    height: auto !important;
  }
  .product-booking-section {
    width: 48% !important;
  }
}
@media (max-width: 425px) {
  .product-information-div {
    width: 100% !important;
    overflow-y: auto !important;
    height: auto !important;
  }
  .product-booking-section {
    width: 100% !important;
  }
}
@keyframes timerBlink {
  0% {
    background-color: #d2042d;
  }

  50% {
    background-color: #fb7185;
  }

  100% {
    background-color: #d2042d;
  }
}
.product-reservation-timer-warning {
  animation: timerBlink 1s infinite;
}

.quantity-container {
  width: 100%;
  border: 1.213px solid #ddd;
  border-radius: 12px;
  min-height: 60px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: #fff;
  font-size: 14px;
  font-weight: 500;
  font-family: Roboto;
  padding-block: 8px;
}

.quantity-info {
  display: flex;
  flex-direction: column;
  font-family: Roboto;
}

.quantity-title {
  font-size: 14px;
  font-weight: 600;
  color: #364153;
  font-family: Roboto;
}

.quantity-subtitle {
  font-size: 14px;
  font-weight: 600;
  color: #99a1af;
}

.quantity-title,
.quantity-subtitle {
  margin: 0;
}

.quantity-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.quantity-btn {
  width: 32px !important;
  height: 32px !important;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #d1d5dc;
}

.quantity-btn:hover {
  background-color: #f6f3f4 !important;
  border: 1px solid #d1d5dc;
  border-color: #d1d5dc !important;
  color: #4a5565 !important;
}
.quantity-btn-disabled {
  background: #f5f5f5 !important;
  color: #bfbfbf !important;
  cursor: not-allowed;
}
.quantity-btn-disabled:hover {
  color: #bfbfbf !important;
}
.quantity-value {
  width: 20px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #d2042d;
  font-family: Roboto;
}
.date-range-display {
  width: 100%;
  min-height: 44px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  margin-top: 15px;
  border: 1px solid #d2042d;
  border-radius: 12px;
  background: #ffe5eb;
  color: #d2042d;
  font-size: 14px;
}

.range-days {
  margin-left: auto;
  font-weight: 600;
  white-space: nowrap;
}

.date-range-display .delete-range-btn {
  margin-left: 10px;
  cursor: pointer;
}
.main-product-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: crosshair;
}

.zoom-lens,
.product-image-zoom {
  position: absolute;
  pointer-events: none;
}

.zoom-lens {
  background: rgba(255, 255, 255, 0.35);
  border: 1px solid rgba(0, 0, 0, 0.25);
  z-index: 2;
}

.product-image-zoom {
  position: absolute;
  top: 0;
  left: calc(100% + 16px);
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-color: #fff;
  border: 1px solid #ddd;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  pointer-events: none;
}
.is-inner-zoom {
  overflow: hidden;
  cursor: zoom-in;
}

.is-inner-zoom .product-image-zoom {
  left: 0;
  border: none;
  box-shadow: none;
  z-index: 2;
}

/* dragging the zoomed image on touch screens */
.is-touch-zooming {
  touch-action: none;
  cursor: zoom-out;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/product-details/web/ProductDetailPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB,EAAE,YAAY;EACjC,eAAe;AACjB;AACA;EACE;IACE,uBAAuB,EAAE,WAAW;EACtC;AACF;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA,2CAA2C;AAC3C;EACE,gBAAgB,EAAE,yCAAyC;EAC3D,WAAW,EAAE,4BAA4B;AAC3C;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,wDAAwD;EACxD,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,uCAAuC;IACvC,wCAAwC;EAC1C;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;EACA;;KAEG;AACL;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;AACF;AACA;EACE,oBAAoB;EACpB,qBAAqB,EAAE,oBAAoB;EAC3C,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,wBAAwB;EACxB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;;;GAGG;AACH;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;;IAEhB,sBAAsB;EACxB;EACA;IACE,qBAAqB;IACrB,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,sBAAsB;EACtB,0CAA0C;EAC1C,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".product-info-card {\n  max-height: 181vh;\n  height: auto;\n  min-height: 584px;\n  border-radius: 10px;\n}\n.product-site-no {\n  font-size: 13px;\n  color: #d2042d;\n}\n.product-info-card .product-title {\n  font-size: 17px;\n  font-weight: 600;\n  color: #0a0a0a;\n  font-family: Roboto;\n}\n.product-info-card .product-location {\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto;\n  color: #d2042d;\n}\n.product-info-card .product-location-details {\n  font-size: 16px;\n  color: #4b4b4b;\n  font-family: Roboto;\n}\n.price-breakdown-info-text {\n  font-size: 12px;\n  color: #7a7a7a;\n  margin-left: 4px;\n  font-family: Roboto;\n}\n.price-breakdown-info {\n  display: flex;\n  align-items: center; /* desktop */\n  margin-top: 5px;\n}\n@media (max-width: 768px) {\n  .price-breakdown-info {\n    align-items: flex-start; /* mobile */\n  }\n}\n.price-breakdown-info svg {\n  flex-shrink: 0;\n}\n\n.view-full-price-breakdown {\n  font-size: 16px;\n  color: #d2042d;\n  font-family: Roboto;\n  text-decoration: underline;\n}\n.product-type-container {\n  margin-top: 8px;\n  padding: 4px 8px;\n  display: inline-block;\n  background-color: #1a1919;\n  border-radius: 4px;\n}\n.product-info-card .product-price {\n  font-size: 20px;\n  font-weight: 700;\n  font-family: Roboto;\n  color: #0a0a0a;\n}\n.select-campaign-dropdown-div {\n  position: sticky;\n  width: 100% !important;\n}\n\n.audience-breakdown-card {\n  height: 309px;\n  border-radius: 10px;\n}\n.product-performance-card {\n  height: auto;\n  border-radius: 10px;\n}\n.product-performance-title {\n  font-size: 14px;\n  font-weight: 600;\n  font-family: Roboto;\n  color: #0a0a0a;\n}\n.breadcrumb-nav-container {\n  margin-top: 16px;\n}\n\n.product-type-label {\n  font-size: 14px;\n  color: #5b5e5d;\n  font-family: Roboto;\n}\n\n.product-availability-text {\n  font-size: 14px;\n  color: #5b5e5d;\n  font-family: Roboto;\n}\n.product-type-value {\n  font-size: 14px;\n  font-family: Roboto;\n  color: #0a0f0d;\n}\n.product-location-card {\n  height: auto;\n  border-radius: 10px;\n}\n.product-seller-info-card {\n  height: 162px;\n  border-radius: 10px;\n}\n.product-pricebooking-card {\n  width: 100%;\n  height: auto;\n  border-radius: 10px;\n}\n/* Ensure single month panel is displayed */\n.single-panel-picker .ant-picker-panels {\n  min-width: 280px; /* Minimum width for single month panel */\n  width: auto; /* Let it resize if needed */\n}\n.similar-product-image-container {\n  width: 399px;\n  height: 229px;\n}\n.similar-product-id {\n  font-size: 14px;\n  color: #8e9190;\n  font-family: Roboto;\n}\n.similar-product-title {\n  font-size: 16px;\n  font-weight: 500;\n  font-family: Roboto;\n  color: #0a0a0a;\n}\n.similar-product-date {\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto;\n}\n.similar-product-specification-label {\n  font-size: 14px;\n  color: #5b5e5d;\n  font-family: Roboto;\n  font-weight: 400;\n}\n.similar-product-card {\n  width: 449px;\n  height: 649px;\n}\n\n.impressions-column {\n  color: #3b3f3d;\n  font-size: 14px;\n  font-family: Roboto;\n  font-weight: 400;\n}\n.audience-breakdown-total {\n  color: #0a0f0d;\n  font-size: 16px;\n  font-family: Roboto;\n  font-weight: 500;\n}\n.maps-card-section {\n  flex: 1;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  margin-top: 16px;\n}\n.map-billboard-card .ant-card-body {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 16px;\n}\n.card-width-adjustments {\n  padding-top: 10px;\n  padding-right: 20px;\n  width: 100%;\n}\n.google-map-container {\n  background: lightgray 50% / cover no-repeat;\n  border-radius: 19px;\n}\n.booking-policy-section {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 24px;\n}\n.product-detail-image-container {\n  height: 400px;\n  width: 90%;\n}\n.price-breakdown-popover-content {\n  width: 326px;\n  padding: 16px 10px;\n}\n.breakdown-price-label {\n  font-size: 16px;\n  color: #707070;\n  font-weight: 400;\n  font-family: Roboto;\n}\n.breakdown-amount {\n  font-size: 16px;\n  color: #0a0f0d;\n  font-weight: 500;\n  font-family: Roboto;\n}\n.price-breakdown-divider .ant-divider-horizontal {\n  margin: 8px 0;\n}\n.select-quantity-dropdown {\n  font-family: Roboto;\n  display: flex;\n  height: 50px;\n  padding: 10px 20px;\n  align-items: center;\n  gap: 8px;\n  border-radius: 5px;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d);\n  position: sticky;\n  width: 21vw !important;\n}\n.product-information-div {\n  width: 74.5%;\n  height: 125vh;\n  overflow-y: auto;\n}\n.product-booking-section {\n  width: 25%;\n}\n.radio-btn-campaign {\n  font-size: 14px;\n  font-family: Roboto;\n  font-weight: 400;\n}\n.error-text {\n  font-size: 14px;\n  color: #d2042d;\n  font-family: Roboto;\n}\n.warning-msg-text {\n  font-size: 14px;\n  color: #5b5e5d;\n  font-family: Roboto;\n  font-weight: 400;\n}\n\n.minimum-err-txt-container {\n  background-color: #fee1e7;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  padding: 8px;\n  border-radius: 12px;\n  margin-top: 8px;\n}\n.ant-drawer-content-wrapper {\n  pointer-events: none;\n}\n.ant-drawer-content {\n  pointer-events: auto;\n}\n.ant-select-dropdown {\n  position: fixed !important;\n}\n.ant-drawer {\n  transform: none !important;\n}\n\n.ant-select-dropdown {\n  position: fixed !important;\n  z-index: 2000 !important;\n}\n\n@media (max-width: 1250px) {\n  .audience-breakdown-card {\n    height: auto;\n    border-radius: 10px;\n    max-height: auto;\n  }\n  .product-performance-card {\n    height: auto;\n    border-radius: 10px;\n  }\n  .product-location-card {\n    height: auto;\n    max-height: auto;\n    border-radius: 10px;\n  }\n}\n\n@media (max-width: 1199px) {\n  .card-width-adjustments {\n    padding-top: 10px;\n    padding-right: 20px;\n    width: 100%;\n    margin-left: 20px;\n  }\n  .product-detail-image-container {\n    height: 400px;\n    width: 100%;\n  }\n  .product-highlight-detail {\n    margin-top: 21vh;\n  }\n}\n\n@media (max-width: 1024px) {\n  .product-info-outer {\n    display: flex;\n    flex-direction: row;\n  }\n  .product-information-div {\n    width: 60%;\n    height: 125vh;\n    overflow-y: auto;\n  }\n  .product-booking-section {\n    width: 40%;\n  }\n}\n@media (max-width: 996px) {\n  .product-highlight-detail {\n    margin-top: 16vh;\n  }\n  .product-info-card {\n    max-height: 181vh;\n    height: auto;\n    min-height: 564px;\n    border-radius: 10px;\n  }\n  .ant-drawer .ant-drawer-content {\n    border-top-left-radius: 30px !important;\n    border-top-right-radius: 30px !important;\n  }\n  .audience-breakdown-card {\n    height: auto;\n  }\n  .maps-card-section {\n    height: 100%;\n    width: 100%;\n    margin-top: 16px;\n  }\n  .product-pricebooking-card {\n    width: 100%;\n    height: auto;\n    border-radius: 10px;\n  }\n  .product-detail-image-container {\n    height: 400px;\n    width: 100%;\n  }\n  .select-campaign-dropdown-div {\n    position: sticky;\n    width: 100% !important;\n  }\n  .select-quantity-dropdown {\n    position: sticky;\n    max-width: 59vw;\n    width: auto;\n    min-width: 59vw;\n  }\n  .product-information-div {\n    width: 100%;\n    height: 88vh;\n    overflow-y: auto;\n  }\n  /* .product-booking-section {\n    display: none;\n  } */\n}\n.product-info-outer {\n  display: flex;\n  flex-direction: row;\n}\n.custom-calendar-popup {\n  width: 100% !important;\n  inset: 25px auto auto 8px !important;\n}\n@media (max-width: 500px) {\n  .product-info-outer {\n    display: flex;\n    flex-direction: column;\n  }\n  .product-information-div {\n    width: 100% !important;\n  }\n  .product-booking-section {\n    width: 100% !important;\n  }\n}\n\n@media (max-width: 500px) {\n  .select-quantity-dropdown {\n    position: sticky;\n    max-width: 93vw;\n    width: auto;\n    min-width: 87vw;\n  }\n  .select-campaign-dropdown-div {\n    position: sticky;\n    width: 100% !important;\n  }\n}\n.multiline-truncate {\n  display: -webkit-box;\n  -webkit-line-clamp: 5; /* Number of lines */\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.fixed-bottom-bar-add-to-campaign {\n  position: fixed !important;\n  bottom: 0 !important;\n  z-index: 1000 !important;\n  width: 100% !important;\n  border-radius: 0 !important;\n}\n\n@media (max-width: 440px) {\n  .product-detail-image-container {\n    height: 70%;\n  }\n  .product-highlight-detail {\n    margin-top: 3vh;\n  }\n  .product-info-card .product-title {\n    font-size: 20px;\n  }\n}\n/* .multi-slot-range-picker {\n  width: 0 !important;\n  overflow: hidden;\n} */\n.multi-slot-range-picker.ant-picker {\n  border: none !important;\n}\n.multi-slot-range-picker .ant-picker-input {\n  display: none !important;\n}\n.multi-slot-range-picker .ant-picker-range-separator {\n  display: none !important;\n}\n\n.multi-slot-range-picker .ant-picker-suffix {\n  display: none !important;\n}\n.multi-slot-range-picker .ant-picker-clear {\n  display: none !important;\n}\n\n.multi-range-selection-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 375px;\n  width: 100%;\n  max-height: 40vh;\n  overflow: auto;\n}\n\n.multi-range-selection-box {\n  width: 100%;\n  border: 1.213px solid #ddd;\n  border-radius: 12px;\n  min-height: 44px;\n  padding: 0 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  /* color: #6b7280; */\n  font-size: 14px;\n  font-weight: 500;\n  background: #fff;\n  font-family: Roboto;\n}\n.multi-range-selection-box.clickable-range {\n  cursor: pointer;\n}\n.active-range {\n  border: 1px solid #d2042d;\n  background-color: #fee1e7;\n  color: #d2042d;\n}\n\n.range-arrow {\n  color: #d90429;\n}\n\n.add-another-range-btn {\n  border: 1px dashed #d9d9d9;\n  border-radius: 12px;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #8c8c8c;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  background: #fff;\n  gap: 7px;\n  font-family: Roboto;\n}\n\n.add-another-range-btn:hover {\n  border-color: #9ca3af;\n  color: #374151;\n}\n\n.multi-slot-popup {\n  z-index: 10 !important;\n}\n\n.delete-range-btn {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #e03b59;\n}\n\n.delete-range-btn:hover {\n  color: #d10b15;\n}\n\n.disabled-add-range {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.view-slots-link {\n  font-family: Roboto;\n  cursor: pointer;\n  color: #d2042d;\n  text-decoration: underline;\n}\n.product-reservation-banner {\n  width: 97%;\n  background: #fff1f2;\n  border: 1px solid #fca5a5;\n  border-top: 4px solid #d2042d;\n  border-radius: 16px;\n  overflow: hidden;\n  margin-bottom: 24px;\n  margin-top: 10px;\n}\n\n.product-reservation-main {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 20px;\n}\n\n.product-reservation-icon {\n  width: 48px;\n  height: 48px;\n  background: #ffe4e6;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.product-reservation-icon .anticon {\n  color: #d2042d;\n  font-size: 22px;\n}\n\n.product-reservation-content {\n  flex: 1;\n}\n\n.product-reservation-title {\n  color: #d2042d;\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.product-reservation-text {\n  color: #344054;\n  font-size: 14px;\n  line-height: 22px;\n}\n\n.product-reservation-timer-wrapper {\n  min-width: 170px;\n  text-align: center;\n}\n\n.product-reservation-timer-label {\n  font-size: 13px;\n  color: #667085;\n  margin-bottom: 8px;\n}\n\n.product-reservation-timer {\n  background: #344054;\n  height: 52px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.product-reservation-timer .anticon {\n  color: #fff;\n  font-size: 18px;\n}\n\n.product-reservation-footer-label {\n  margin-top: 8px;\n  color: #667085;\n  font-size: 12px;\n}\n\n.product-reservation-footer {\n  background-color: #fff8f8;\n  border-top: 1px solid #fca5a5;\n  padding: 12px 20px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #667085;\n  font-size: 13px;\n}\n.product-reservation-footer .anticon {\n  color: #d2042d;\n}\n\n@media (max-width: 768px) {\n  .product-reservation-main {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .product-reservation-icon {\n    align-self: center;\n  }\n  .product-reservation-content {\n    width: 100%;\n    text-align: center;\n  }\n  .product-reservation-timer-wrapper {\n    width: 100%;\n  }\n  .product-reservation-timer {\n    width: 100%;\n  }\n  .product-reservation-footer {\n    align-items: flex-start;\n  }\n  .select-campaign-dropdown-div {\n    position: sticky;\n\n    width: 100% !important;\n  }\n  .product-information-div {\n    width: 52% !important;\n    overflow-y: auto !important;\n    height: auto !important;\n  }\n  .product-booking-section {\n    width: 48% !important;\n  }\n}\n@media (max-width: 425px) {\n  .product-information-div {\n    width: 100% !important;\n    overflow-y: auto !important;\n    height: auto !important;\n  }\n  .product-booking-section {\n    width: 100% !important;\n  }\n}\n@keyframes timerBlink {\n  0% {\n    background-color: #d2042d;\n  }\n\n  50% {\n    background-color: #fb7185;\n  }\n\n  100% {\n    background-color: #d2042d;\n  }\n}\n.product-reservation-timer-warning {\n  animation: timerBlink 1s infinite;\n}\n\n.quantity-container {\n  width: 100%;\n  border: 1.213px solid #ddd;\n  border-radius: 12px;\n  min-height: 60px;\n  padding: 0 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  background: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: Roboto;\n  padding-block: 8px;\n}\n\n.quantity-info {\n  display: flex;\n  flex-direction: column;\n  font-family: Roboto;\n}\n\n.quantity-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #364153;\n  font-family: Roboto;\n}\n\n.quantity-subtitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: #99a1af;\n}\n\n.quantity-title,\n.quantity-subtitle {\n  margin: 0;\n}\n\n.quantity-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.quantity-btn {\n  width: 32px !important;\n  height: 32px !important;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 600;\n  border: 1px solid #d1d5dc;\n}\n\n.quantity-btn:hover {\n  background-color: #f6f3f4 !important;\n  border: 1px solid #d1d5dc;\n  border-color: #d1d5dc !important;\n  color: #4a5565 !important;\n}\n.quantity-btn-disabled {\n  background: #f5f5f5 !important;\n  color: #bfbfbf !important;\n  cursor: not-allowed;\n}\n.quantity-btn-disabled:hover {\n  color: #bfbfbf !important;\n}\n.quantity-value {\n  width: 20px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 600;\n  color: #d2042d;\n  font-family: Roboto;\n}\n.date-range-display {\n  width: 100%;\n  min-height: 44px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  margin-top: 15px;\n  border: 1px solid #d2042d;\n  border-radius: 12px;\n  background: #ffe5eb;\n  color: #d2042d;\n  font-size: 14px;\n}\n\n.range-days {\n  margin-left: auto;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.date-range-display .delete-range-btn {\n  margin-left: 10px;\n  cursor: pointer;\n}\n.main-product-image-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  cursor: crosshair;\n}\n\n.zoom-lens,\n.product-image-zoom {\n  position: absolute;\n  pointer-events: none;\n}\n\n.zoom-lens {\n  background: rgba(255, 255, 255, 0.35);\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  z-index: 2;\n}\n\n.product-image-zoom {\n  position: absolute;\n  top: 0;\n  left: calc(100% + 16px);\n  width: 100%;\n  height: 100%;\n  background-repeat: no-repeat;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  pointer-events: none;\n}\n.is-inner-zoom {\n  overflow: hidden;\n  cursor: zoom-in;\n}\n\n.is-inner-zoom .product-image-zoom {\n  left: 0;\n  border: none;\n  box-shadow: none;\n  z-index: 2;\n}\n\n/* dragging the zoomed image on touch screens */\n.is-touch-zooming {\n  touch-action: none;\n  cursor: zoom-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
